import type {DesignSelection} from '@Components/social-media/social-media.types';

export const GALLERY_DESIGN_CLICKED_EVENT = 'gallery-design-clicked';
// Twin of GALLERY_UPLOAD_MEDIA_CLICKED_EVENT in public/assets/javascript/views/modal/gallery-dialog.js
export const GALLERY_UPLOAD_MEDIA_CLICKED_EVENT = 'gallery-upload-media-clicked';
// Twin of GALLERY_CREATE_WITH_AI_CLICKED_EVENT in public/assets/javascript/views/modal/gallery-dialog.js
export const GALLERY_CREATE_WITH_AI_CLICKED_EVENT = 'gallery-create-with-ai-clicked';

export interface GalleryDesignClickedEventDetail {
  id?: string;
  idPage?: string;
}

export interface DesignGalleryProps {
  onDesignsSelected: (designs: DesignSelection[]) => void;
  onUploadMediaClick?: () => void;
  onCreateWithAiClick?: () => void;
  disableCreateFromScratchCTA?: boolean;
  height?: string;
  startingPageURI?: GalleryPageURI;
}

export enum GalleryThemeURI {
  DEFAULT = 'posters/gallery',
  CHRISTMAS = 'g/christmas-posters',
  EVENTS = 'g/event-flyers',
  RETAIL = 'g/retail-sale-posters',
  // Add more /g/ URIs here as needed
}

export enum GallerySizeURI {
  SOCIAL_MEDIA = 'sizes/social-media-templates/all/all',
  POSTERS = 'sizes/posters/all/all',
  // Add more /sizes/ URIs here as needed
}

export type SizesPageURI = `sizes/${string}`;
export type CategoryPageURI = `g/${string}`;
export type SubcategoryPageURI = `s/${string}`;

export type GalleryPageURI = GallerySizeURI | GalleryThemeURI | SizesPageURI | CategoryPageURI | SubcategoryPageURI;
